import { useStore } from '@nanostores/react';
import { accountStore } from '@/services/auth/store';
import { VerificationReviewState, VerificationState, type RawAccount } from '@/services/auth/types';

/**
 * Whether the account passed the anti-abuse verification review. Single swap
 * point: the checklist, the `/onboarding` bounce, and the go-live gate all
 * read it. Takes the account so the pre-auth signup landing can use it too.
 */
export function isAccountVerified(account: Pick<RawAccount, 'verification_state'> | null | undefined): boolean {
  return account?.verification_state === VerificationState.Approved;
}

/** Store-backed reader, for use inside the authenticated tree. */
export function useIsAccountVerified(): boolean {
  return isAccountVerified(useStore(accountStore));
}

/**
 * Whether the review is waiting on the customer. Rejection is deliberately not
 * included: a rejected account gets the takeover instead of the checklist, so
 * there is no step for it to act on.
 */
export function useVerificationNeedsAction(): boolean {
  return useStore(accountStore)?.verification_review_state === VerificationReviewState.NeedsMoreInfo;
}

export function useIsAccountRejected(): boolean {
  return useStore(accountStore)?.verification_state === VerificationState.Rejected;
}
